var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuctionManager(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    viewBox: "0 0 160 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 144,
    height: 104,
    rx: 12,
    fill: "#FFF7E6",
    stroke: "#FFD59E",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 42,
    width: 32,
    height: 12,
    rx: 6,
    fill: "#FFCE73"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 60,
    width: 32,
    height: 12,
    rx: 6,
    fill: "#FFCE73"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 78,
    width: 32,
    height: 12,
    rx: 6,
    fill: "#FFCE73"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 38,
    width: 48,
    height: 44,
    rx: 10,
    fill: "#FFE4B8",
    stroke: "#FFCE73",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 52H112",
    stroke: "#FF9F1C",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64H112",
    stroke: "#FF9F1C",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76H112",
    stroke: "#FF9F1C",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 52,
    r: 6,
    fill: "#18B46A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 64,
    r: 6,
    fill: "#18B46A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 76,
    r: 6,
    fill: "#18B46A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 28L64 20L76 28V90H52V28Z",
    fill: "#25416A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86H74",
    stroke: "#F4F9FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuctionManager);
export default __webpack_public_path__ + "static/media/auction-manager.2878beca87a4a6758f4bf5629fd0fafa.svg";
export { ForwardRef as ReactComponent };